import React from 'react';
import SEO from '../component/SEO';
import '../styles/whatsnew.scss';
import PageShapes from '../component/PageShapes';
import { Link } from 'react-router-dom';

const updates = [
     {
          date: 'Apr 22, 2026',
          name: 'Edit Feature',
          image: require('../assets/WhatsNew/item-editing.png'),
          title: 'Post Editing — Now Live',
          subtitle: 'Edit your submitted ideas anytime',
          description: 'Users can now edit their own submitted posts directly from the Overview page or the detail page. A smooth offcanvas panel opens with title, problem, and rich content editor — powered by ReactQuill.',
          link: '/overview',
          linkLabel: 'Go to Overview',
     },
     {
          date: 'Apr 20, 2026',
          name: 'Ad Integration',
          image: require('../assets/WhatsNew/item-ad-Integration.png'),
          title: 'HeyPrompt AI Image Generator Ad',
          subtitle: 'Promoting our sister product',
          description: 'Added a promotional banner for HeyPrompt\'s free AI image generator inside the idea detail page. Login and create stunning AI images instantly.',
          link: 'https://heyprompt.online/ai-image-generator',
          linkLabel: 'Try HeyPrompt',
          external: true,
     },
     {
          date: 'Apr 18, 2026',
          name: 'Engagement Metrics',
          image: null,
          title: 'Icons Added to Metrics',
          subtitle: 'Visual upgrade for likes, comments & interested',
          description: 'MUI icons were added to the engagement metrics section — ThumbUp for Likes, ChatBubble for Comments, and Star for Interested count. Makes the UI more intuitive.',
          link: '/explore',
          linkLabel: 'Explore Ideas',
     },
     {
          date: 'Apr 15, 2026',
          name: 'Overview Tabs',
          image: null,
          title: 'Public & Private Tab Separation',
          subtitle: 'Better organization of your posts',
          description: 'The Overview page now separates your posts into Public and Private tabs based on visibility setting. Each tab shows the correct count and filters items accordingly.',
          link: '/overview',
          linkLabel: 'View Overview',
     },
     {
          date: 'Apr 10, 2026',
          name: 'Detail Page',
          image: null,
          title: 'Immersive Idea Detail Page',
          subtitle: 'Full story-style layout for each idea',
          description: 'Redesigned the idea detail page with a story-style layout — meta strip, author row, metrics bar, rich content section, and a comments section at the bottom.',
          link: '/explore',
          linkLabel: 'Browse Ideas',
     },
     {
          date: 'Apr 5, 2026',
          name: 'Comments',
          image: null,
          title: 'Comments System',
          subtitle: 'Discuss ideas with the community',
          description: 'Added a full comments system — users can write, view, and engage with comments on any idea. Comments are stored in Firestore and load in real-time.',
          link: '/explore',
          linkLabel: 'See Ideas',
     },
];

const WhatsNew = () => {
     return (
          <>
               <SEO title="What's New — HaveIdea" description="Latest features and updates added to HaveIdea platform." />
               <PageShapes />
               <div className="whatsnew-page">
                    <div className="whatsnew-container">

                         <div className="whatsnew-header">
                              <h1>What's <span>New</span></h1>
                              <p>A timeline of features and improvements shipped to the platform.</p>
                         </div>

                         <div className="timeline">
                              {updates.map((item, i) => (
                                   <div className="timeline-item" key={i}>

                                        {/* Left — date & name */}
                                        <div className="timeline-left">
                                             <span className="tl-date">{item.date}</span>
                                             <span className="tl-name">{item.name}</span>
                                        </div>

                                        {/* Center — dot + lines */}
                                        <div className="timeline-center">
                                             <div className="tl-dot" />
                                        </div>

                                        {/* Right — article */}
                                        <div className="timeline-right">
                                             {item.image && (
                                                  <Link to={item.link}> 
                                                       <img src={item.image} alt={item.title} className="tl-img" />
                                                  </Link>
                                             )}
                                             <h3 className="tl-title">{item.title}</h3>
                                             <h5 className="tl-subtitle">{item.subtitle}</h5>
                                             <p className="tl-desc">{item.description}</p>
                                             {item.link && (
                                                  item.external
                                                       ? <Link to={item.link} target="_blank" rel="noreferrer" className="tl-link">{item.linkLabel} →</Link>
                                                       : <Link to={item.link} className="tl-link">{item.linkLabel} →</Link>
                                             )}
                                             {i < updates.length - 1 && <hr className="tl-divider" />}
                                        </div>

                                   </div>
                              ))}
                         </div>

                    </div>
               </div>
          </>
     );
};

export default WhatsNew;
